<template>
  <div class="bg-white min-h-screen">
    <CContainer>
      <div class="header-bar">
        <CButton class="back-btn" aria-label="Go back" @click="goBack">
          <svg viewBox="0 0 24 24" class="icon-back">
            <line x1="19" y1="12" x2="5" y2="12" />
            <polyline points="12 19 5 12 12 5" />
          </svg>
        </CButton>
        <h2 class="center-title">Notification Preferences</h2>
      </div>

      <div class="prefs">
        <div
          v-for="(section, sIdx) in notifications"
          :key="sIdx"
          class="prefs-group"
        >
          <h4 class="group-title">{{ section.title }}</h4>

          <div
            v-for="(item, iIdx) in section.items"
            :key="iIdx"
            class="pref-row"
          >
            <span class="pref-label">{{ item.label }}</span>

            <label class="ios-toggle">
              <input type="checkbox" v-model="item.enabled" />
              <span class="slider"></span>
            </label>
          </div>
        </div>

        <div class="spacer" />
      </div>
    </CContainer>
  </div>
</template>

<script>
import Footerlayout from "../containers/TheBottomCustom.vue"; // kalau dipakai di layout bawah

export default {
  name: "NotificationPreferences",
  components: { Footerlayout },
  data() {
    return {
      notifications: [
        {
          title: "Special tips and offers",
          items: [
            { label: "New survey opportunities", enabled: false },
            { label: "Voucher expiry reminders", enabled: false },
            { label: "Company announcements", enabled: false },
          ],
        },
        {
          title: "Personal Notifications",
          items: [
            { label: "Survey results", enabled: false },
            { label: "Voucher updates", enabled: false },
          ],
        },
        {
          title: "Public Updates",
          items: [
            { label: "New surveys", enabled: false },
            { label: "Trending vouchers", enabled: false },
          ],
        },
      ],
    };
  },
  methods: {
    goBack() {
      if (window.history.length > 1) this.$router.go(-1);
      else this.$router.push("Home");
    },
  },
};
</script>

<style scoped>
.header-bar {
  position: relative;
  height: 75px;
  margin-bottom: 4px;
}
.back-btn {
  position: absolute;
  left: 4px;
  top: 50%;
  transform: translateY(-50%);
  width: 44px;
  height: 44px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  color: #111827;
  cursor: pointer;
}
.icon-back {
  width: 22px;
  height: 22px;
  stroke: currentColor;
  fill: none;
  stroke-width: 2.5;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.center-title {
  position: absolute;
  left: 50%;
  width: 200px;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #111827;
}

/* === Body === */
.prefs {
  padding-top: 8px;
}
.prefs-group + .prefs-group {
  margin-top: 10px;
}
.group-title {
  font-size: 16px;
  font-weight: 600;
  color: #7b8a9c;
  margin: 14px 0 4px;
}

/* Baris item */
.pref-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 2px;
}
.pref-label {
  font-size: 14px;
  color: #191919;
}

.ios-toggle {
  position: relative;
  width: 46px;
  height: 28px;
  display: inline-block;
}
.ios-toggle input {
  display: none;
}
.ios-toggle .slider {
  position: absolute;
  inset: 0;
  background: #eceff3;
  border-radius: 999px;
  transition: background 0.2s ease;
  box-shadow: inset 0 0 0 1px #e2e5ea;
}
.ios-toggle .slider::before {
  content: "";
  position: absolute;
  left: 3px;
  top: 50%;
  transform: translateY(-50%);
  width: 22px;
  height: 22px;
  background: #ffffff;
  border-radius: 50%;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
  transition: left 0.2s ease;
}
.ios-toggle input:checked + .slider {
  background: #7e73fd;
  box-shadow: inset 0 0 0 1px #7e73fd;
}
.ios-toggle input:checked + .slider::before {
  left: 21px;
}
.ios-toggle input:disabled + .slider {
  opacity: 0.5;
}

.spacer {
  height: 80px;
}
</style>
